/*
 * Checking the chat list against the server, by content.
 *
 * Prod, 2026-11-04, chat -P5Z3u5xs0nA0FM2CMKV: a PCA's list stopped showing new
 * chats while its connection was healthy. The freshness check
 * (connectionMonitor.checkChatListFreshness) wrote, the server answered, so it
 * saw nothing wrong; only a hard reload showed the chat. The likely cause: the
 * list's listeners on /openconversations were cancelled by the server (reads
 * need a signed-in user, so a lapse while the hourly sign-in token refreshes
 * ends them) and nothing noticed. So the list is now also compared with the
 * server's own answer to "which open chats are assigned to me", and rebuilt
 * when they differ (ConversationAction.verifyChatList).
 */

/* Whether the chat list shows this open chat: the filter its listeners use
   (ConversationAction fetchConversations). */
export const isListedOpenChat = (chat) => Boolean(
    chat &&
    chat.status &&
    chat.patientID &&
    !chat.clinical_chat &&
    !chat.isDelegate
);

/* The IDs of `serverChats` ({id: chat}, the PCA's open chats on the server) that
   the list should show but does not. `shownIDs` is a Set of the list's IDs. */
export const missingFromList = (serverChats, shownIDs) => Object.entries(serverChats || {})
    .filter(([id, chat]) => isListedOpenChat(chat) && !shownIDs.has(id))
    .map(([id]) => id);

/* Rebuilding the list waits this long between failed attempts (the sign-in
   token is refreshed first, so a lapse has time to clear). */
export const RECOVERY_DELAYS_MS = [3000, 10000, 30000, 60000, 120000];

export const recoveryDelay = (attempt, immediate = false) => {
    if (immediate && attempt === 0) return 0;
    return RECOVERY_DELAYS_MS[Math.min(attempt, RECOVERY_DELAYS_MS.length - 1)];
};

/* A chat assigned a moment ago can be on the server before the listeners deliver
   it; a missing chat is looked at again after this before the list is rebuilt. */
export const MISSING_GRACE_MS = 5000;
